<template>
  <div
    class="wh100"
    v-loading.fullscreen.lock="loading"
    style="overflow-y: auto"
  >
    <el-row class="cen-search" style="text-align: right; margin-top: 10px">
      <el-col :span="6" style="display: flex">
        <span>年月：</span>
        <el-date-picker
          v-model="searchData.YearMonth"
          type="month"
          placeholder="选择月份"
          value-format="yyyyMM"
          format="yyyy-MM"
          :clearable="false"
          style="width: 80%"
          @change="getDataInfo"
        ></el-date-picker>
      </el-col>
    </el-row>
    <div class="cen-top">
      <el-row class="wh100" :gutter="10">
        <el-col :span="6"
          ><el-card
            style="
              background-color: #ed7d31;
              color: #fff;
              font-size: 18px;
              font-weight: bold;
              border-radius: 20px;
            "
          >
            <div
              slot="header"
              style="height: 50px; padding: 18px"
              class="flex-juc-aic"
            >
              待检
            </div>
            <div class="w100" style="height: calc(100% - 50px); display: flex">
              <div class="flex-juc-aic wh100">
                <span class="num">{{
                  dataInfo.PendingInspectionDeviceCount || 0
                }}</span
                ><span class="text">台</span>
              </div>
              <div class="flex-juc-aic wh100">
                <span class="num">{{
                  dataInfo.PendingInspectionTerm || 0
                }}</span
                ><span class="text">项</span>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="6"
          ><el-card
            style="
              background-color: #6aac3d;
              color: #fff;
              font-size: 18px;
              font-weight: bold;
              border-radius: 20px;
            "
          >
            <div
              slot="header"
              style="height: 50px; padding: 18px"
              class="flex-juc-aic"
            >
              完成
            </div>
            <div class="w100" style="height: calc(100% - 50px); display: flex">
              <div class="flex-juc-aic wh100">
                <span class="num">{{ dataInfo.CompleteDeviceCount || 0 }}</span
                ><span class="text">台</span>
              </div>
              <div class="flex-juc-aic wh100">
                <span class="num">{{ dataInfo.CompleteTerm || 0 }}</span
                ><span class="text">项</span>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="6"
          ><el-card
            style="
              background-color: #ffc601;
              color: #fff;
              font-size: 18px;
              font-weight: bold;
              border-radius: 20px;
            "
          >
            <div
              slot="header"
              style="height: 50px; padding: 18px"
              class="flex-juc-aic"
            >
              维检中
            </div>
            <div class="w100" style="height: calc(100% - 50px); display: flex">
              <div class="flex-juc-aic wh100">
                <span class="num">{{
                  dataInfo.MaintenanceDeviceCount || 0
                }}</span
                ><span class="text">台</span>
              </div>
              <div class="flex-juc-aic wh100">
                <span class="num">{{ dataInfo.MaintenanceTerm || 0 }}</span
                ><span class="text">项</span>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card style="padding: 10px; border-radius: 20px">
            <div
              style="
                font-size: 16px;
                font-weight: bold;
                height: 20px;
                text-align: center;
                display: flex;
                align-items: center;
                justify-content: space-between;
              "
            >
              <el-button @click="handleCalendar('prev-month')" type="text"
                >上个月</el-button
              >
              <span cliass="span"> {{ calendar }}</span>
              <el-button @click="handleCalendar('next-month')" type="text"
                >下个月</el-button
              >
            </div>
            <el-calendar
              :first-day-of-week="7"
              ref="calendar"
              v-model="dateCalendar"
            >
              <template slot="dateCell" slot-scope="{ date }">
                <div
                  style="display: inline-block; width: 100%; height: 100%"
                  @click="
                    calendarData(
                      dataInfo.WorkOrderList?.find(
                        (item) =>
                          item.WorkOrderDate ===
                          moment(date).format('YYYY-MM-DD')
                      ),
                      date
                    )
                  "
                >
                  <el-badge
                    :value="
                      dataInfo.WorkOrderList?.find(
                        (item) =>
                          item.WorkOrderDate ===
                          moment(date).format('YYYY-MM-DD')
                      ).Num
                    "
                    class="itembadge"
                    v-if="
                      dataInfo.WorkOrderList?.findIndex(
                        (item) =>
                          item.WorkOrderDate ===
                          moment(date).format('YYYY-MM-DD')
                      ) !== -1
                    "
                  >
                    {{ moment(date).format('DD') }}
                  </el-badge>
                  <div
                    style="
                      display: inline-block;
                      width: 100%;
                      height: 100%l;
                      line-height: 1;
                    "
                    v-else
                  >
                    {{ moment(date).format('DD') }}
                  </div>
                </div>
              </template>
            </el-calendar>
          </el-card></el-col
        >
      </el-row>
    </div>

    <div class="cen-ter">
      <el-row class="wh100" :gutter="10">
        <el-col :span="6"
          ><el-card>
            <div
              slot="header"
              style="
                height: 50px;
                padding: 18px;
                justify-content: left;
                font-size: 18px;
                font-weight: bold;
                justify-content: space-between;
              "
              class="flex-juc-aic"
            >
              <div class="flex-juc-aic">
                <img
                  src="@/assets/baoyang.png"
                  alt=""
                  style="width: 30px; height: 30px; margin-right: 10px"
                />
                保养工单
              </div>

              <el-button
                type="text"
                icon="el-icon-plus"
                @click="addDeviceEditForm('1')"
                >添加工单</el-button
              >
            </div>
            <div
              style="height: calc(100% - 50px); overflow-y: auto; padding: 10px"
            >
              <el-card
                v-for="item in dataInfo.MaintenanceTask"
                :key="item.Id"
                style="height: auto; margin-bottom: 10px"
              >
                <div slot="header" class="titleFi">
                  <div>
                    <span cliass="span">{{ item.DeviceItemName }}</span>
                    <span cliass="span">（{{ item.DeviceItemCode }}）</span>
                  </div>
                  <el-button type="text" @click="openView(item)">
                    查看详情
                  </el-button>
                </div>
                <div style="padding: 15px 0px">
                  <div style="display: flex">
                    <el-tooltip
                      effect="dark"
                      :content="`工单编号：${item.Code}`"
                      placement="top"
                      :open-delay="300"
                    >
                      <div class="item">
                        <span cliass="span">工单编号：</span>
                        <div class="p">{{ item.Code }}</div>
                      </div>
                    </el-tooltip>
                    <el-tooltip
                      effect="dark"
                      :content="`类型：${item.TypeName}`"
                      placement="top"
                      :open-delay="300"
                    >
                      <div class="item">
                        <span cliass="span">类型：</span>
                        <div class="p">{{ item.TypeName }}</div>
                      </div>
                    </el-tooltip>
                  </div>

                  <div style="display: flex; margin-top: 10px">
                    <el-tooltip
                      effect="dark"
                      :content="`工单日期：${
                        item.WorkOrderDate
                          ? moment(item.WorkOrderDate).format('YYYY-MM-DD')
                          : ''
                      }`"
                      placement="top"
                      :open-delay="300"
                    >
                      <div class="item">
                        <span cliass="span">工单日期：</span>
                        <div class="p">
                          {{
                            item.WorkOrderDate
                              ? moment(item.WorkOrderDate).format('YYYY-MM-DD')
                              : ''
                          }}
                        </div>
                      </div>
                    </el-tooltip>
                    <el-tooltip
                      effect="dark"
                      :content="`状态：${
                        item.State === 0
                          ? '待提交'
                          : item.State === 1
                          ? '已提交'
                          : item.State === 2
                          ? '进行中'
                          : item.State === 3
                          ? '已完成'
                          : ''
                      }`"
                      placement="top"
                      :open-delay="300"
                    >
                      <div class="item">
                        <span cliass="span">状态：</span>
                        <div class="p">
                          <el-tag v-if="item.State === 0">待提交</el-tag>
                          <el-tag type="success" v-if="item.State === 1"
                            >已提交</el-tag
                          >
                          <el-tag type="warning" v-if="item.State === 2"
                            >进行中</el-tag
                          >
                          <el-tag type="success" v-if="item.State === 3"
                            >已完成</el-tag
                          >
                        </div>
                      </div>
                    </el-tooltip>
                  </div>
                  <div style="display: flex; margin-top: 10px">
                    <el-tooltip
                      effect="dark"
                      :content="`安装位置：${item.InstallationAreaName}`"
                      placement="top"
                      :open-delay="300"
                    >
                      <div class="item">
                        <span cliass="span">安装位置：</span>
                        <div class="p">
                          {{ item.InstallationAreaName }}
                        </div>
                      </div>
                    </el-tooltip>
                  </div>
                </div>
              </el-card>
            </div>
          </el-card>
        </el-col>
        <el-col :span="6"
          ><el-card>
            <div
              slot="header"
              style="
                height: 50px;
                padding: 18px;
                justify-content: left;
                font-size: 18px;
                font-weight: bold;
                justify-content: space-between;
              "
              class="flex-juc-aic"
            >
              <div class="flex-juc-aic">
                <img
                  src="@/assets/weixiu.png"
                  alt=""
                  style="width: 30px; height: 30px; margin-right: 10px"
                />
                维修工单
              </div>
              <el-button
                type="text"
                icon="el-icon-plus"
                @click="addDeviceEditForm('2')"
                >添加工单</el-button
              >
            </div>
            <div
              style="height: calc(100% - 50px); overflow-y: auto; padding: 10px"
            >
              <el-card
                v-for="item in dataInfo.MaintainabilityTask"
                :key="item.Id"
                style="height: auto; margin-bottom: 10px"
              >
                <div slot="header" class="titleFi">
                  <div>
                    <span cliass="span">{{ item.DeviceItemName }}</span>
                    <span cliass="span">（{{ item.DeviceItemCode }}）</span>
                  </div>
                  <el-button type="text" @click="openView(item)">
                    查看详情
                  </el-button>
                </div>
                <div style="padding: 15px 0px">
                  <div style="display: flex">
                    <el-tooltip
                      effect="dark"
                      :content="`工单编号：${item.Code}`"
                      placement="top"
                      :open-delay="300"
                    >
                      <div class="item">
                        <span cliass="span">工单编号：</span>
                        <div class="p">{{ item.Code }}</div>
                      </div>
                    </el-tooltip>
                    <el-tooltip
                      effect="dark"
                      :content="`类型：${item.TypeName}`"
                      placement="top"
                      :open-delay="300"
                    >
                      <div class="item">
                        <span cliass="span">类型：</span>
                        <div class="p">{{ item.TypeName }}</div>
                      </div>
                    </el-tooltip>
                  </div>

                  <div style="display: flex; margin-top: 10px">
                    <el-tooltip
                      effect="dark"
                      :content="`工单日期：${
                        item.WorkOrderDate
                          ? moment(item.WorkOrderDate).format('YYYY-MM-DD')
                          : ''
                      }`"
                      placement="top"
                      :open-delay="300"
                    >
                      <div class="item">
                        <span cliass="span">工单日期：</span>
                        <div class="p">
                          {{
                            item.WorkOrderDate
                              ? moment(item.WorkOrderDate).format('YYYY-MM-DD')
                              : ''
                          }}
                        </div>
                      </div>
                    </el-tooltip>
                    <el-tooltip
                      effect="dark"
                      :content="`状态：${
                        item.State === 0
                          ? '待提交'
                          : item.State === 1
                          ? '已提交'
                          : item.State === 2
                          ? '进行中'
                          : item.State === 3
                          ? '已完成'
                          : ''
                      }`"
                      placement="top"
                      :open-delay="300"
                    >
                      <div class="item">
                        <span cliass="span">状态：</span>
                        <div class="p">
                          <el-tag v-if="item.State === 0">待提交</el-tag>
                          <el-tag type="success" v-if="item.State === 1"
                            >已提交</el-tag
                          >
                          <el-tag type="warning" v-if="item.State === 2"
                            >进行中</el-tag
                          >
                          <el-tag type="success" v-if="item.State === 3"
                            >已完成</el-tag
                          >
                        </div>
                      </div>
                    </el-tooltip>
                  </div>
                  <div style="display: flex; margin-top: 10px">
                    <el-tooltip
                      effect="dark"
                      :content="`安装位置：${item.InstallationAreaName}`"
                      placement="top"
                      :open-delay="300"
                    >
                      <div class="item">
                        <span cliass="span">安装位置：</span>
                        <div class="p">
                          {{ item.InstallationAreaName }}
                        </div>
                      </div>
                    </el-tooltip>
                  </div>
                </div>
              </el-card>
            </div>
          </el-card>
        </el-col>

        <el-col :span="6"
          ><el-card>
            <div
              slot="header"
              style="
                height: 50px;
                padding: 18px;
                justify-content: left;
                font-size: 18px;
                font-weight: bold;
                justify-content: space-between;
              "
              class="flex-juc-aic"
            >
              <div class="flex-juc-aic">
                <img
                  src="@/assets/xunjian.png"
                  alt=""
                  style="width: 30px; height: 30px; margin-right: 10px"
                />
                巡检工单
              </div>
              <el-button
                type="text"
                icon="el-icon-plus"
                @click="addDeviceEditForm('0')"
                >添加工单</el-button
              >
            </div>
            <div
              style="height: calc(100% - 50px); overflow-y: auto; padding: 10px"
            >
              <el-card
                v-for="item in dataInfo.InspectionTask"
                :key="item.Id"
                style="height: auto; margin-bottom: 10px"
              >
                <div slot="header" class="titleFi">
                  <div>
                    <span cliass="span">{{ item.DeviceItemName }}</span>
                    <span cliass="span">（{{ item.DeviceItemCode }}）</span>
                  </div>
                  <el-button type="text" @click="openView(item)">
                    查看详情
                  </el-button>
                </div>
                <div style="padding: 15px 0px">
                  <div style="display: flex">
                    <el-tooltip
                      effect="dark"
                      :content="`工单编号：${item.Code}`"
                      placement="top"
                      :open-delay="300"
                    >
                      <div class="item">
                        <span cliass="span">工单编号：</span>
                        <div class="p">{{ item.Code }}</div>
                      </div>
                    </el-tooltip>
                    <el-tooltip
                      effect="dark"
                      :content="`类型：${item.TypeName}`"
                      placement="top"
                      :open-delay="300"
                    >
                      <div class="item">
                        <span cliass="span">类型：</span>
                        <div class="p">{{ item.TypeName }}</div>
                      </div>
                    </el-tooltip>
                  </div>

                  <div style="display: flex; margin-top: 10px">
                    <el-tooltip
                      effect="dark"
                      :content="`工单日期：${
                        item.WorkOrderDate
                          ? moment(item.WorkOrderDate).format('YYYY-MM-DD')
                          : ''
                      }`"
                      placement="top"
                      :open-delay="300"
                    >
                      <div class="item">
                        <span cliass="span">工单日期：</span>
                        <div class="p">
                          {{
                            item.WorkOrderDate
                              ? moment(item.WorkOrderDate).format('YYYY-MM-DD')
                              : ''
                          }}
                        </div>
                      </div>
                    </el-tooltip>
                    <el-tooltip
                      effect="dark"
                      :content="`状态：${
                        item.State === 0
                          ? '待提交'
                          : item.State === 1
                          ? '已提交'
                          : item.State === 2
                          ? '进行中'
                          : item.State === 3
                          ? '已完成'
                          : ''
                      }`"
                      placement="top"
                      :open-delay="300"
                    >
                      <div class="item">
                        <span cliass="span">状态：</span>
                        <div class="p">
                          <el-tag v-if="item.State === 0">待提交</el-tag>
                          <el-tag type="success" v-if="item.State === 1"
                            >已提交</el-tag
                          >
                          <el-tag type="warning" v-if="item.State === 2"
                            >进行中</el-tag
                          >
                          <el-tag type="success" v-if="item.State === 3"
                            >已完成</el-tag
                          >
                        </div>
                      </div>
                    </el-tooltip>
                  </div>
                  <div style="display: flex; margin-top: 10px">
                    <el-tooltip
                      effect="dark"
                      :content="`安装位置：${item.InstallationAreaName}`"
                      placement="top"
                      :open-delay="300"
                    >
                      <div class="item">
                        <span cliass="span">安装位置：</span>
                        <div class="p">
                          {{ item.InstallationAreaName }}
                        </div>
                      </div>
                    </el-tooltip>
                  </div>
                </div>
              </el-card>
            </div>
          </el-card>
        </el-col>
        <el-col :span="6"
          ><el-card style="background-color: rgb(253, 240, 248)">
            <div
              slot="header"
              style="
                height: 50px;
                padding: 18px;
                justify-content: left;
                font-size: 18px;
                font-weight: bold;
                justify-content: space-between;
              "
              class="flex-juc-aic"
            >
              <div class="flex-juc-aic">
                <img
                  src="@/assets/waiwei2.png"
                  alt=""
                  style="width: 30px; height: 30px; margin-right: 10px"
                />
                外委工单
              </div>
              <el-button
                type="text"
                icon="el-icon-plus"
                @click="addDeviceEditForm('3')"
                >添加工单</el-button
              >
            </div>
            <div
              style="height: calc(100% - 50px); overflow-y: auto; padding: 10px"
            >
              <el-card
                v-for="item in dataInfo.OutsourcingTask"
                :key="item.Id"
                style="height: auto; margin-bottom: 10px"
              >
                <div slot="header" class="titleFi">
                  <div>
                    <span cliass="span">{{ item.DeviceItemName }}</span>
                    <span cliass="span">（{{ item.DeviceItemCode }}）</span>
                  </div>
                  <el-button type="text" @click="openView(item)">
                    查看详情
                  </el-button>
                </div>
                <div style="padding: 15px 0px">
                  <div style="display: flex">
                    <el-tooltip
                      effect="dark"
                      :content="`工单编号：${item.Code}`"
                      placement="top"
                      :open-delay="300"
                    >
                      <div class="item">
                        <span cliass="span">工单编号：</span>
                        <div class="p">{{ item.Code }}</div>
                      </div>
                    </el-tooltip>
                    <el-tooltip
                      effect="dark"
                      :content="`类型：${item.TypeName}`"
                      placement="top"
                      :open-delay="300"
                    >
                      <div class="item">
                        <span cliass="span">类型：</span>
                        <div class="p">{{ item.TypeName }}</div>
                      </div>
                    </el-tooltip>
                  </div>

                  <div style="display: flex; margin-top: 10px">
                    <el-tooltip
                      effect="dark"
                      :content="`工单日期：${
                        item.WorkOrderDate
                          ? moment(item.WorkOrderDate).format('YYYY-MM-DD')
                          : ''
                      }`"
                      placement="top"
                      :open-delay="300"
                    >
                      <div class="item">
                        <span cliass="span">工单日期：</span>
                        <div class="p">
                          {{
                            item.WorkOrderDate
                              ? moment(item.WorkOrderDate).format('YYYY-MM-DD')
                              : ''
                          }}
                        </div>
                      </div>
                    </el-tooltip>
                    <el-tooltip
                      effect="dark"
                      :content="`状态：${
                        item.State === 0
                          ? '待提交'
                          : item.State === 1
                          ? '已提交'
                          : item.State === 2
                          ? '进行中'
                          : item.State === 3
                          ? '已完成'
                          : ''
                      }`"
                      placement="top"
                      :open-delay="300"
                    >
                      <div class="item">
                        <span cliass="span">状态：</span>
                        <div class="p">
                          <el-tag v-if="item.State === 0">待提交</el-tag>
                          <el-tag type="success" v-if="item.State === 1"
                            >已提交</el-tag
                          >
                          <el-tag type="warning" v-if="item.State === 2"
                            >进行中</el-tag
                          >
                          <el-tag type="success" v-if="item.State === 3"
                            >已完成</el-tag
                          >
                        </div>
                      </div>
                    </el-tooltip>
                  </div>
                  <div style="display: flex; margin-top: 10px">
                    <el-tooltip
                      effect="dark"
                      :content="`安装位置：${item.InstallationAreaName}`"
                      placement="top"
                      :open-delay="300"
                    >
                      <div class="item">
                        <span cliass="span">安装位置：</span>
                        <div class="p">
                          {{ item.InstallationAreaName }}
                        </div>
                      </div>
                    </el-tooltip>
                    <el-tooltip
                      effect="dark"
                      :content="`供应商：${item.SupplierName}`"
                      placement="top"
                      :open-delay="300"
                    >
                      <div class="item">
                        <span cliass="span">供应商：</span>
                        <div class="p">
                          {{ item.SupplierName }}
                        </div>
                      </div>
                    </el-tooltip>
                  </div>
                </div>
              </el-card>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <EditForm ref="EditForm" @success="getDataInfo"></EditForm>
    <DeviceEditForm
      ref="DeviceEditForm"
      @success="getDataInfo"
    ></DeviceEditForm>
  </div>
</template>
<script>
import moment from 'moment'
import EditForm from '@/views/Operation/OperationTaskPlanning/EditForm.vue'
import DeviceEditForm from '@/views/Operation/OperationWorkOrder/EditForm.vue'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      moment,
      loading: false,
      searchData: {
        YearMonth: '',
      },
      dataInfo: {},
      dateCalendar: '',
      calendar: moment().format('YYYY-MM-DD'),
    }
  },
  props: {},
  components: { EditForm, DeviceEditForm },
  methods: {
    addDeviceEditForm(WorkOrderType) {
      console.log(WorkOrderType, 'WorkOrderType')
      this.$refs.DeviceEditForm.openForm(
        '新建工单',
        {},
        false,
        {},
        WorkOrderType
      )
    },
    openView(item) {
      this.$emit('openView', item)
    },
    calendarData(item) {
      console.log(item)
      // console.log(date, "date");
      // setTimeout(() => {
      //   this.dateCalendar = moment(date).format("YYYY-MM-DD");
      // }, 1);
      if (item) {
        this.$emit('WorkOrder', item)
        // this.$refs.WorkOrder.openForm(item.WorkOrderDate + "工单详情", item);
      }
    },
    handleCalendar(str) {
      this.$refs.calendar.selectDate(str)
      console.log(this.$refs.calendar.selectDate, 'this.$refs.calendar')
    },
    getDataInfo() {
      this.loading = true
      this.$http
        .post('/PB/PB_Project/GetDeviceMaintenanceStatistics', {
          Search: [
            {
              Condition: 'DeviceType',
              Keyword: this.devTreeSearch.DeviceType || '',
            },
            {
              Condition: 'BuildingId',
              Keyword: this.devTreeSearch.BuildingId || '',
            },
            {
              Condition: 'InstallationArea',
              Keyword: this.devTreeSearch.InstallationArea || '',
            },
            {
              Condition: 'TreeType',
              Keyword: this.devTreeSearch.TreeType || 0,
            },
            {
              Condition: 'YearMonth',
              Keyword: this.searchData.YearMonth || '',
            },
          ],
        })
        .then((res) => {
          this.loading = false
          if (res.Success) {
            this.dataInfo = res.Data || {}
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },
    handleAdd() {
      this.$refs.EditForm.openForm('新建任务计划')
    },
  },
  mounted() {},
  created() {
    this.searchData.YearMonth = moment().format('YYYYMM')
    this.getDataInfo()
  },
  computed: {
    ...mapState(['devTreeSearch']),
  },
  watch: {
    devTreeSearch() {
      this.getDataInfo()
    },
    dateCalendar(a, b) {
      console.log(a, b)
      this.calendar = moment(a).format('YYYY-MM-DD')
      console.log(moment(a).format('YYYY-MM-DD'))
    },
  },
}
</script>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.cen-top {
  width: 100%;
  min-height: 200px;
  height: 20%;
  padding: 5px;
}
.cen-search {
  width: 100%;
  height: 40px;

  padding: 5px;
}
.cen-ter {
  // height: calc(80% - 40px);
  // // min-height: calc(100% - 200px);
  // max-height: calc(100% - 240px);
  width: 100%;
  padding: 5px;
}
.cen-top,
.cen-ter {
  ::v-deep .el-card {
    width: 100%;
    height: 100%;
    .el-card__header {
      padding: 0;
    }
    .el-card__body {
      height: 100%;
      width: 100%;
      padding: 0;
    }
  }
}
::v-deep .el-col {
  height: 100%;
}
::v-deep .cen-ter {
  .el-card {
    border-radius: 10px;
  }
}
.titleFi {
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.item {
  font-size: 12px;
  display: flex;
  width: 50%;
  align-items: center;
  // white-space: pre-wrap; /* 这使得文本可以换行 */
  // word-wrap: break-word;
  span {
    display: inline-block;
    width: 70px;
    text-align: right;
  }
  .p {
    width: calc(100% - 70px);
    display: inline-block;
    white-space: nowrap; /* 防止文本换行 */
    overflow: hidden; /* 隐藏溢出的文本 */
    text-overflow: ellipsis;
    span {
      display: inline;
    }
  }
}
.num {
  font-size: 70px;
}
.text {
  font-size: 20px;
  margin-left: 5px;
  margin-top: 30px;
}
.itembadge {
  font-size: 12px;
}
</style>
